<section *ngIf="!isInvisible" class="title">
  <div class="wrapper">
    <div class="upper text">
      <div>
        <h1 *ngIf="titles && titles.length > 0">
          <span *ngFor="let item of titles; let i = index">
            <br *ngIf="i > 0" /> {{ item | translate }}
          </span>
        </h1>
      </div>
    </div>
  </div>
</section>
